import { EMOTIONS_CHAR as EmotionsChar } from '../assets'

import { GET, PUT, POST, PATCH, DELETE } from './request'
import { 
  UPLOAD_MANY_IMAGE, 
  UPLOAD_SINGLE_IMAGE,
  GET_QINIU_TOKEN,
  UPLOAD_MANY_IMAGE_WITH_TOKEN,
  UPLOAD_SINGLE_IMAGE_WITH_TOKEN
} from './upload'
import { URLS } from './url'
import { SET_VALUE, GET_VALUE, REMOVE_VALUE, CLEAR_VALUE } from './storage'
var Utils = {
  // isMobile: navigator.userAgent.includes("Mobile"),
  getTimeString: time => time.slice(0, 19).replace("T", " "),
  /**
   * 将时间字符串处理成 “5分钟前” 这种形式
   */
  dealWithTime: time => {
    var timeArray = time.split('.')[0].split('T')
    var year = timeArray[0].split('-')[0]
    var month = timeArray[0].split('-')[1]
    var day = timeArray[0].split('-')[2]

    var hour = timeArray[1].split(':')[0]
    var minute = timeArray[1].split(':')[1]
    var second = timeArray[1].split(':')[2]

    var create = new Date(year, month - 1, day, hour, minute, second)
    var current = new Date()
    var s1 = current.getTime() - create.getTime() // 相差的毫秒
    var str = null
    if (s1 / (60 * 1000) < 1) {
      str = '刚刚'
    } else if (s1 / (60 * 1000) < 60) {
      str = parseInt(s1 / (60 * 1000)) + '分钟前'
    } else if (s1 / (60 * 1000) < 24 * 60) {
      str = parseInt(s1 / (60 * 60 * 1000)) + '小时前'
    } else if (s1 / (60 * 1000) < 24 * 60 * 2) {
      str = '昨天 ' + time.slice(11, 16)
    } else {
      str = time.slice(0, 10).replace('T', ' ')
    }
    return str
  },

  // 转义符
  replaceChar: (content) => {
    // &amp(&)、&lt;(<)、&gt;(>)、&#39(单引号')、&quot;(双引号")
    return String(content || '')
      .replace(/&(?!#?[a-zA-Z0-9]+;)/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/'/g, '&#39;')
      .replace(/"/g, '&quot;')
  },
  // 替换图片字符串
  replaceImgString: (content) => {
    // img[https://static1.bcjiaoyu.com/f517bf872d5a1704cfed3e4bac7b28a0_h.png-1920x1080]
    return content.replace(/img\[([^\s]+?)\]/g, function (img) {
      let url = img.replace(/(^img\[)|(\]$)/g, '')
      return `<img style="width:300px;display:block;" src="${url}"/>`
    })
  },
  // 转义表情
  replaceEmoijString: (content) => {
    // [微笑][哈哈] , /\[(.*?)\]/g  所有字符除了换行符(.)
    return content.replace(/\[(.*?)\]/g, function (emoij_key) {
      // [微笑]
      if (Object.keys(EmotionsChar).includes(emoij_key)) {
        if (EmotionsChar[emoij_key]['src']) {
          // 表情图片
          let src = EmotionsChar[emoij_key]['src']
          // let html = `<div class="emoij" style="width:25px; height:25px; display:inline-flex; align-items:center;justify-content:center;">
          //               <img style="width:15px;" src="${src}"/>
          //             </div>`;
          let imgH = 16
          let html = `<img style="height:${imgH}px;margin-right:4px;display:inline-block;vertical-align: middle;" src="${src}"/>`
          return html
        } else {
          // 表情字符
          let text = EmotionsChar[emoij_key]['text']
          let emoijSize = 18
          let html = `<span style="font-size:${emoijSize}px;vertical-align: middle;">${text}</span>`
          return html
          // return text;
        }
      }
      return emoij_key
    })
  },
  // 转义链接
  replaceLinkString: (content, tag = null) => {
    if (!tag) {
      // 第一种：事先定义好的一种格式: a(链接)[链接文本描述]
      // a(http://www.baidu.com)[http://www.baidu.com] a(链接)[链接文本描述]
      // /a\([\s\S]+?\)\[[\s\S]*?\]/g  [\s\S]代表所有字符
      return content.replace(/a\([\s\S]+?\)\[[\s\S]*?\]/g, function (str) {
        // a(链接)[链接文本描述]
        var href = (str.match(/a\(([\s\S]+?)\)\[/) || [])[1]
        var text = (str.match(/\)\[([\s\S]*?)\]/) || [])[1]
        if (!href) return str
        var rel = /^(http(s)*:\/\/)\b(?!(\w+\.)*(sentsin.com|layui.com))\b/.test(
          href.replace(/\s/g, '')
        )
        return `<a class="link" href="${href}" target="_blank">${text || href}</a>`
      })
    } else {
      // 第二种：普通地址格式: http(s)://
      var re = /(http(s)?:\/\/[\w.\/]+)(?![^<]+>)/gi
      var re = /(http(s)?:\/\/[\w.\/]+[\?\w=]+[\s\S&amp;]*?)(?![^<]+>)/gi
      var re = /(http(s)?:\/\/[\w.\/]+[\?\S]*)(?![^<]+>)/gi
      var re = /(http(s)?:\/\/[\w.\/]+([^\?\S]*))(?![^<]+>)/gi
      var re = /((http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?)/gi
      content = content.replace(re, "<a style='text-decoration: underline;color:#6b45e1;' target='_blank' href='$1'>$1</a>")
      return content
    }
  },
  // 转义代码
  replaceCodeString: (content) => {
    // [pre]代码块[/pre] 哈哈哈[pre]你好[/pre]
    return content.replace(/\[pre\][\s\S]*?\[\/pre\]/g, function (str) {
      // [pre]代码块[/pre]
      var code = str.match(/\[pre\]([\s\S]*?)\[\/pre\]/)[1]
      if (!code) return str
      let startHtml = `<pre style="padding: 10px 15px;margin: 10px 0;font-size: 12px;border: 1px solid #ddd;border-left-width: 6px;background-color: #f5f5f5;font-family: Courier New;overflow: auto;border-radius: 4px;line-height:1.5;white-space: pre-wrap;word-wrap: break-word;word-break: break-word;">${code}</pre>`
      return startHtml
    })
  },
  // 转义换行
  replaceLineString: (content) => {
    return content.replace(/\n/g, '<br>')
  },
  // 转义@功能 
  replaceAttentionString: (content) => {
    // @小明 哈哈哈@小红 , /@(.+?) /g
    var re = /@(.+?) /g
    content = content.replace(re, `<span style="color:#6b45e1;">@$1 </span>`)
    return content;
  },
  // 转义给定字符串
  escape: (content) => {
    let charString = Utils.replaceChar(content)
    let imgString = Utils.replaceImgString(charString)
    let linkString = Utils.replaceLinkString(imgString)
    linkString = Utils.replaceLinkString(linkString, 'common')
    let codeString = Utils.replaceCodeString(linkString)
    let lineString = Utils.replaceLineString(codeString)
    let emoijString = Utils.replaceEmoijString(lineString)
    let attentionString = Utils.replaceAttentionString(emoijString)
    let result = attentionString

    return result
  },

  /**
   * 用 “<br/>” 替换字符串中的换行符
   */
  formatString: msg => {
    if (!msg) return ''
    return msg.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>')
  },

  /**
   * 替换字符串中的转义表情字符，如 [鬼] -> 👻
   */
  replaceEmotionString: str => {
    var nickname = str
    // 将名称中带有转义的表情字符，转一下[鬼]->👻
    var keys = Object.keys(EmotionsChar)
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]
      if (nickname.includes(key) === true) {
        // 找到子串了
        let value = EmotionsChar[key]['src']
          ? `<img class="img_emoij" style="height:15px; " src="${EmotionsChar[key]['src']}"/>`
          : EmotionsChar[key]['text']
        key = '\\' + key
        // console.log(key);
        let reg = new RegExp(key, 'g')
        nickname = nickname.replace(reg, value)
        // console.log(nickname);
      }
    }
    return nickname
  },
  /**
   * 将图片地址转义符号处理，取缩略图
   */
  getImg: (url, isThumb = true) => {
    url = url?url:''
    let newUrl = url
    if (url.includes('https://') || url.includes('http://')) {
      if (isThumb === true && url.includes('static1.bcjiaoyu.com')) {
        newUrl = url + '-200x200'
      }
    }
    if(!isThumb && newUrl.includes('static1.bcjiaoyu.com')){
      newUrl = newUrl + '-autoOrient'
    }
    if (newUrl.includes("'")) {
      newUrl = newUrl.replace(/'/g, '%27')
    }

    if (newUrl.includes(' ')) {
      newUrl = newUrl.replace(/ /g, '%20')
    }
    // newUrl = encodeURI(newUrl)
    return newUrl
  }
}

export {
  GET,
  PUT,
  POST,
  PATCH,
  DELETE,
  UPLOAD_MANY_IMAGE,
  UPLOAD_SINGLE_IMAGE,
  GET_QINIU_TOKEN,
  UPLOAD_SINGLE_IMAGE_WITH_TOKEN,
  UPLOAD_MANY_IMAGE_WITH_TOKEN,
  URLS,
  SET_VALUE,
  GET_VALUE,
  REMOVE_VALUE,
  CLEAR_VALUE,
  Utils
}
